import React from 'react'
import { TabPanel } from 'react-tabs'
import type { PanelProps } from './types'

export const Panel = ({ style, children, ...other }: PanelProps) => {
  return (
    <TabPanel {...other}>
      <div style={style}>{children}</div>
    </TabPanel>
  )
}

Panel.tabsRole = 'TabPanel'
